import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=c1aab386&scoped=true&"
var script = {}
import style0 from "./Download.vue?vue&type=style&index=0&id=c1aab386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aab386",
  null
  
)

export default component.exports